import './ExperienceCard.css';

function ExperienceCard({ experience }) {
    return (
        <div className="experience-card">
            <h3>{experience.position}</h3>
            <p>{experience.company}</p>
            <p dangerouslySetInnerHTML={{ __html: experience.description }} />
            <p>{new Date(experience.started_at).toLocaleDateString()} - {new Date(experience.ended_at).toLocaleDateString()}</p>
        </div>
    );
}

export default ExperienceCard;